import styled from "styled-components";

export const ContainerRegister = styled.section`
  .container__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2.25rem;
    margin-top: 2.25rem;
  }
`;
